import { SendOutlined } from "@ant-design/icons"
import { App, Button, Modal } from "antd"
import { useState } from "react"

import Flex from "#blocks/Flex"
import { useApiContext } from "#contexts/ApiContextProvider"

import CorgiPopup from "./CorgiPopup"
import FormattedTextBlock from "./FormattedTextBlock"

interface ErrorFallbackModalProps {
  title: string
  error?: Error
  resetError?: () => void
}

const ErrorFallbackModal = ({
  title = "Oops! Something went wrong",
  error,
  resetError,
}: ErrorFallbackModalProps) => {
  const [isOpen, setIsOpen] = useState(true)

  const { apiHandler } = useApiContext()
  const { sendErrorToDevs } = apiHandler
  const { message } = App.useApp()

  const closeModal = () => {
    setIsOpen(false)
  }

  return (
    <Modal
      open={isOpen}
      width={800}
      footer={[
        <Button key="cancel" onClick={closeModal}>
          Close
        </Button>,
      ]}
      onCancel={closeModal}
    >
      <CorgiPopup title={title}>
        {error && (
          <Flex col gap={16}>
            <Flex
              col
              style={{
                gap: 8,
                backgroundColor: "rgba(0,0,0,0.05)",
                borderRadius: 8,
                padding: 12,
              }}
            >
              Error details:
              <FormattedTextBlock
                text={error.message}
                style={{ fontSize: 12 }}
              />
            </Flex>
            <Flex>
              <Button
                key="sendToDevs"
                onClick={async () => {
                  await sendErrorToDevs(
                    "Error fallback",
                    error.message,
                    "Error fallback"
                  )
                  message.success("Error sent! Thanks for your help!")
                }}
              >
                <SendOutlined />
                Send to devs
              </Button>
            </Flex>
          </Flex>
        )}

        {resetError && (
          <Button
            type="primary"
            size="large"
            onClick={resetError}
            style={{ width: "fit-content" }}
          >
            Try again
          </Button>
        )}
      </CorgiPopup>
    </Modal>
  )
}

export default ErrorFallbackModal
